import classes from './RadioFieldCustom.module.css'

const RadioButtonCustom = ({item, checked, changeHandler, name}) => {

    return <div  className={`${classes.radio_filed_item} ${item.error_message ? classes.input_disabled : ''}`}>
        <input type="radio" id={item.price_quote_id} name={name} value={item.price_quote_id} checked={checked} onChange={changeHandler} disabled={item.error_message}/>
        <label htmlFor={item.price_quote_id} className={classes.label}>

            <div className={classes.block}>
                <div className={classes.text}>
                    <div className={classes.text_title}>{item.display_name}</div>
                    {!item.error_message && <>
                        {item.price_explanation_text} - {Math.round(item.estimated_duration_seconds / 60)} min drop-off
                    </>}
                    
                    {item.error_message && <div className={classes.lyft_error}>
                        {item.error_message}
                    </div>}
                </div>
                {!item.error_message && <div className={classes.price}>
                    ${(item.estimated_cost_cents_max/100).toFixed(2)}
                </div>}

                
            </div>
        </label>
    </div>
}

export default RadioButtonCustom